import { Box, Button, Card, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import Header from '../Header'
import Footer from '../Footer';
import { styles } from '../../styles/styles';
import { DecorativeCorner } from '../../common/DecorativeCorner';
import Cmdimage from '../../homepage/Cmd.png';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import RateReviewIcon from '@mui/icons-material/RateReview';
import { FontStyles } from '../../styles/FontStyles';

const Cmd = () => {
    return (
        <>
            <Box>
                <Header />
            </Box>
            <Box sx={{
                marginTop: { xs: "29%", sm: "10%", md: "10%", lg: "10%", xl: "10%" },
                marginBottom:"50px"
            }}>
                <Card
                    sx={{
                        ...styles.cmdcard,
                        boxShadow: 3,
                    }}
                >
                    <DecorativeCorner sx={{ top: -20, left: -20 }} />
                    <DecorativeCorner sx={{ top: -20, right: -20 }} />
                    <DecorativeCorner sx={{ bottom: -20, right: -20 }} />
                    <DecorativeCorner sx={{ bottom: -20, left: -20 }} />

                    <Typography variant="h4" component="h1" sx={FontStyles.heading1}>
                        Annapurna Marriages Pvt Ltd. Chief Managing Director (CMD) Desk
                    </Typography>
                    <Card
                        sx={{
                            ...styles.aboutCard,
                            boxSizing: "border-box",
                            padding:"30px"
                        }}
                    >
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={9}>
                                <Typography sx={{
                                 ...FontStyles. cmdText
                                }}>
                                    Annapurna Marriages Pvt Ltd. is the fastest growing matrimonial portal in Andhra Pradesh, the online matrimonial portal aims to serve as a one-stop platform             for prospective brides and grooms to meet and communicate with each other. It offers a superior matchmaking experience by expanding the opportunities available to meet potential life partners and build fulfilling relationships.<br />
                                </Typography>
                                <Typography sx={{
                                                                   ...FontStyles. cmdText

                                }}>
                                    We use the latest and the most cutting edge technologies available in the online environment to provide members with fast, relevant and best matching results in strict confidence. We also take care of the security or privacy of the members by our special features.              We fulfill the needs of today's eligible singles who are searching for convenient and effective ways to meet with prospective partners.
                                </Typography>
                            </Grid>
                        
                            <Grid item xs={12} md={3}>
                                <Box
                                    component="img"
                                    src={Cmdimage}
                                    alt="Career"
                                    sx={{
                                        width: "200px",
                                        height: "250px",
                                    }}
                                />
                            </Grid>
                            <Grid xs={12} md={12}>
                            <Typography sx={{
                                   ...FontStyles.FeedBack
                                }}>
                                Give Your Feed Back Here
                            </Typography>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Box sx={{ border: "1px solid #C1721F", padding: 3, display: 'flex', flexDirection: 'column', }}>
                                    <Box sx={{ display: "flex" ,alignItems:"start",justifyContent:"start"}}>
                                        <ThumbUpIcon sx={{ color: "#C1721F", fontSize: 30,}} />
                                        <Typography sx={{...FontStyles.FontStyleforCmd}}>Compliments</Typography>     </Box>

                                    <form style={{ width: '100%' }}>
                                        <TextField fullWidth placeholder="Employee ID" sx={{ mb: 2 ,backgroundColor:"#ccc",}} />
                                        <TextField fullWidth placeholder="Mobile Number" sx={{ mb: 2 ,backgroundColor:"#ccc",}} />
                                        <TextField fullWidth placeholder="Write Comment" sx={{ mb: 2 ,backgroundColor:"#ccc",}} />
                                        <Button fullWidth sx={{ ...styles.cmd }}>Submit</Button>
                                    </form>
                                </Box>
                            </Grid>

                            {/* Complaints */}
                            <Grid item xs={12} md={4}>
                                <Box sx={{ border: "1px solid #C1721F", padding: 3, display: 'flex', flexDirection: 'column', }}>
                                    <Box sx={{ display: "flex" }}>
                                        <ThumbDownIcon sx={{ color: "#C1721F", fontSize: 30, }} />
                                        <Typography sx={{...FontStyles.FontStyleforCmd}}>Complaints</Typography>
                                    </Box>
                                    <form style={{ width: '100%' }}>
                                        <TextField fullWidth placeholder="Employee ID" sx={{ mb: 2 ,backgroundColor:"#ccc",}} />
                                        <TextField fullWidth placeholder="Mobile Number" sx={{ mb: 2 ,backgroundColor:"#ccc",}} />
                                        <TextField fullWidth placeholder="Write Complaints" sx={{ mb: 2 ,backgroundColor:"#ccc",}} />
                                        <Button fullWidth sx={{ ...styles.cmd }}>Submit</Button>
                                    </form>
                                </Box>
                            </Grid>

                            {/* Feedback */}
                            <Grid item xs={12} md={4}>
                                <Box sx={{ border: "1px solid #C1721F", padding: 3, display: 'flex', flexDirection: 'column',  }}>
                                    <Box sx={{ display: "flex" }}>

                                        <RateReviewIcon sx={{ color: "#C1721F", fontSize: 30, }} />
                                        <Typography sx={{...FontStyles.FontStyleforCmd}}>We Value Your Feedback</Typography>  </Box>
                                    <form style={{ width: '100%' }}>
                                        <TextField fullWidth placeholder="Employee ID" sx={{ mb: 2 ,backgroundColor:"#ccc",}} />
                                        <TextField fullWidth placeholder="Mobile Number" sx={{ mb: 2 ,backgroundColor:"#ccc",}} />
                                        <TextField fullWidth placeholder="Write Feedback" sx={{ mb: 2 ,backgroundColor:"#ccc",}} />
                                        <Button fullWidth sx={{ ...styles.cmd }}>Submit</Button>
                                    </form>
                                </Box>
                            </Grid>
                        </Grid>
                    </Card>
                </Card>
            </Box>
<Footer/>
        </>
    )
}

export default Cmd